// extracted by mini-css-extract-plugin
module.exports = {"container":"Dadata_container__1SMNh","suggestions":"Dadata_suggestions__2CMHS","suggestion":"Dadata_suggestion__1Bz_3","inn":"Dadata_inn__2nwJQ","option":"Dadata_option__2l75d"};